/* eslint-disable consistent-return */
/* eslint-disable no-prototype-builtins */
import { hasValue } from '../../../general/js/general-helpers';
import { formConstants } from '../components/utils/constants/form-constants';
import { formValidationConstants } from '../components/utils/constants/form-validation-constants';
import { getFormattedEmailRemoveSpaces } from '../store/actions/helpers/data-format-helper';

export function validateEmail(emailText) {
    if (isEmpty(emailText)) {
        return { isValid: false, errorMessage: formValidationConstants.pleaseInputAValue };
    }

    if (!isEmpty(emailText.defaultValue)) return { isValid: true };


    const email = getFormattedEmailRemoveSpaces(emailText);

    const emailPattern = formValidationConstants.emailPattern;
    if (!emailPattern.test(String(email))) {
        return { isValid: false, errorMessage: formValidationConstants.emailAddressErrorMessage };
    }

    if (emailText.includes(formValidationConstants.suttonixDomain) || emailText.includes(formValidationConstants.ecrypseDomain) || emailText.includes(formValidationConstants.dogpilezDomain)) {
        return { isValid: false, errorMessage: formValidationConstants.blockedDomainMessage };
    }

    return { isValid: true };
}

export function validateConfirmEmail(emailText, confirmEmail) {
    if (emailText !== confirmEmail) {
        return { isValid: false, errorMessage: formValidationConstants.confirmEmailErrorMessage };
    }

    if (isEmpty(confirmEmail)) {
        return { isValid: false, errorMessage: formValidationConstants.pleaseInputAValue };
    }

    const emailPattern = formValidationConstants.emailPattern;
    if (!emailPattern.test(String(confirmEmail).toLowerCase())) {
        return { isValid: false, errorMessage: formValidationConstants.emailAddressErrorMessage };
    }

    return { isValid: true };
}

export function validatePassword(passwordText) {
    if (isEmpty(passwordText)) {
        return { isValid: false, errorMessage: formValidationConstants.pleaseInputAValue };
    }

    const passwordPattern = formValidationConstants.passwordPattern;
    if (!passwordPattern.test(String(passwordText))) {
        return { isValid: false, errorMessage: formValidationConstants.passwordErrorMessage };
    }

    return { isValid: true };
}

export function validateNewPassword(password, newPassword) {
    if (password === newPassword) {
        return { isValid: false, errorMessage: formValidationConstants.newPasswordErrorMessage };
    }

    if (isEmpty(newPassword)) {
        return { isValid: false, errorMessage: formValidationConstants.pleaseInputAValue };
    }

    const passwordPattern = formValidationConstants.passwordPattern;
    if (!passwordPattern.test(String(newPassword))) {
        return { isValid: false, errorMessage: formValidationConstants.passwordErrorMessage };
    }

    return { isValid: true };
}

export function validateOldPassword(password, oldPassword) {
    if (password === oldPassword) {
        return { isValid: false, errorMessage: formValidationConstants.oldPasswordErrorMessage };
    }

    if (isEmpty(oldPassword)) {
        return { isValid: false, errorMessage: formValidationConstants.pleaseInputAValue };
    }

    const passwordPattern = formValidationConstants.passwordPattern;
    if (!passwordPattern.test(String(oldPassword))) {
        return { isValid: false, errorMessage: formValidationConstants.passwordErrorMessage };
    }

    return { isValid: true };
}

export function validateConfirmPassword(password, confirmPassword) {
    if (password !== confirmPassword) {
        return { isValid: false, errorMessage: formValidationConstants.confirmPasswordErrorMessage };
    }

    if (isEmpty(confirmPassword)) {
        return { isValid: false, errorMessage: formValidationConstants.pleaseInputAValue };
    }

    const passwordPattern = formValidationConstants.passwordPattern;
    if (!passwordPattern.test(String(confirmPassword))) {
        return { isValid: false, errorMessage: formValidationConstants.passwordErrorMessage };
    }

    return { isValid: true };
}

export function validateSelectedCounty(selectedCounty, selectedCountryCode, county) {
    const availableCounties = county.options.filter(
        (x) => x.countryCode === selectedCountryCode
    );
    const hasCounties = availableCounties && availableCounties.length > 0;

    if (hasCounties) {
        return validateCounty(selectedCounty);
    }

    return { isValid: true };
}

export function validateSelectedState(selectedState, selectedCountryCode, stateField = null) {
    const availableStates = hasValue(stateField) ?
        stateField.options.filter(
            (s) => s.countryCode === selectedCountryCode
        ) :
        [];
    const hasStates = availableStates && availableStates.length > 0;

    if (hasStates) {
        return validateState(selectedState);
    }

    return { isValid: true };
}

export function validateTitle(title) {
    if (isEmpty(title) || title === formValidationConstants.none) {
        return { isValid: false, errorMessage: formValidationConstants.titleErrorMessage };
    }

    if (title.hasOwnProperty(formConstants.defaultValuePropertyName)) {
        if (isEmpty(title[formConstants.defaultValuePropertyName])) {
            return { isValid: false, errorMessage: formValidationConstants.titleErrorMessage };
        }
    }

    return { isValid: true };
}

export function validateCountry(country) {
    if (isEmpty(country) || country === formValidationConstants.none) {
        return { isValid: false, errorMessage: formValidationConstants.countryErrorMessage };
    }

    return { isValid: true };
}

export function validateCounty(county) {
    if (isEmpty(county) || county === formValidationConstants.none) {
        return { isValid: false, errorMessage: formValidationConstants.countyErrorMessage };
    }

    return { isValid: true };
}

export function validateState(stateValue) {
    if (isEmpty(stateValue) || stateValue === formValidationConstants.none) {
        return { isValid: false, errorMessage: formValidationConstants.stateErrorMessage };
    }

    return { isValid: true };
}

export function validateBecomeOneClubMember() {
    return noValidationRequired();
}

export function validateFirstName(text) {
    const validateEmptyString = validateTextValue(text, formValidationConstants.firstNameErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z]+((([,.][ ]{0,1})|([ \'-]))[A-Za-z]+)*$').test(String(text))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersErrorMessage };
    }
}

export function validateLastName(text) {
    const validateEmptyString = validateTextValue(text, formValidationConstants.lastNameErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z]+((([,.][ ]{0,1})|([ \'-]))[A-Za-z]+)*$').test(String(text))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersErrorMessage };
    }
}

export function validateAddressLine1(text) {
    const validateEmptyString = validateTextValue(text, formValidationConstants.addressLine1ErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z0-9]+((([,.][ ]{0,1})|([ \'-]))[A-Za-z0-9]+)*$').test(String(text))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersNumbersErrorMessage };
    }
}

export function validateAddressLine2() {
    return noValidationRequired();
}

export function validateAddressLine3() {
    return noValidationRequired();
}

export function validatePostcode(postCodeText) {
    const validateEmptyString = validateTextValue(postCodeText, formValidationConstants.postcodeErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z0-9]+(([ -])[A-Za-z0-9]+)*$').test(String(postCodeText))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersNumbersLettersErrorMessage };
    }
}

export function validateMobilePhone(mobilePhoneValue, isOptional) {
    if (!isOptional) {
        if (isEmpty(mobilePhoneValue) || mobilePhoneValue.length <= 0) {
            return { isValid: false, errorMessage: formValidationConstants.mobilePhoneErrorMessage };
        }
    }

    if ((mobilePhoneValue.length > 0 && mobilePhoneValue.length < 7) || mobilePhoneValue.length > 15) {
        return {
            isValid: false, errorMessage: formValidationConstants.mobilePhoneErrorMessage
        };
    }
    return { isValid: true };
}

export function validateCity(text) {
    const validateEmptyString = validateTextValue(text, formValidationConstants.cityErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z]+((([,.][ ]{0,1})|([ \'-]))[A-Za-z]+)*$').test(String(text))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersErrorMessage };
    }
}

export function validateMainAddress() {
    return noValidationRequired();
}

export function validateShippingAddress() {
    return noValidationRequired();
}

export function validateBillingAddress() {
    return noValidationRequired();
}

export function validateFavoritePlayer(text) {
    const validateEmptyString = validateTextValue(text, formValidationConstants.favoritePlayerErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z]+((([,.][ ]{0,1})|([ \'-]))[A-Za-z]+)*$').test(String(text))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersErrorMessage };
    }
}

export function validateVenues(venues) { return validateUserChoices(venues, formValidationConstants.venuesErrorMessage); }
export function validateChampionship(championships) { return validateUserChoices(championships, formValidationConstants.championshipSectionErrorMessage); }
export function validateChannels(channels) { return validateUserChoices(channels, formValidationConstants.channelSectionErrorMessage); }
export function validateInterests(interests) { return validateUserChoices(interests, formValidationConstants.interestSectionErrorMessage); }

function validateUserChoices(choices, message) {
    if (!choices || choices.length < 1) {
        return {
            isValid: false, errorMessage: message
        };
    }

    if (choices.every((x) => x === false)) {
        return {
            isValid: false, errorMessage: message
        };
    }

    return { isValid: true };
}
export function validateVerificationCode(verificationCode) {
    const validateEmptyString = validateTextValue(verificationCode, formValidationConstants.verificationCodeErrorMessage);
    if (!validateEmptyString.isValid) {
        return validateEmptyString;
    }

    //validation for special characters
    if (!new RegExp('^[A-Za-z0-9]+(([ -])[A-Za-z0-9]+)*$').test(String(verificationCode))) {
        return { isValid: false, errorMessage: formValidationConstants.specialCharactersNumbersLettersErrorMessage };
    }
}

export function noValidationRequired() {
    return { isValid: true };
}

export function validateRaMemberId(text) {
    if (isEmpty(text)) {
        return {
            isValid: false, errorMessage: formValidationConstants.raMemberIdEmptyErrorMessage
        };
    }

    if (text.length !== 4 || !Number(text) || hasWhiteSpace(text)) {
        return {
            isValid: false, errorMessage: formValidationConstants.raMemberIdInvalidErrorMessage
        };
    }
}

export function validateCaptchaBox(isValid) {
    if (isValid) return { isValid: true };

    return {
        isValid: false, errorMessage: formValidationConstants.captchaInvalidErrorMessage
    };
}

export function validateMastercard(mastercardNumber, mastercardRegex, notMastercardMessage) {
    if (!isEmpty(mastercardNumber)) {
        if (mastercardRegex !== undefined && !new RegExp(mastercardRegex).test(String(mastercardNumber))) {
            return { isValid: false, errorMessage: notMastercardMessage };
        }
    }

    return { isValid: true };
}


function validateTextValue(text, errorMessage) {
    if (isEmpty(text)) {
        return {
            isValid: false, errorMessage
        };
    }
    return { isValid: true };
}

function isEmpty(text) {
    return !text || text === '';
}

function hasWhiteSpace(text) {
    return text.indexOf(' ') >= 0;
}
